// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1_6oM","selects":"Documents_selects__1G4hM"};